import { createSlice } from "@reduxjs/toolkit";

const snackBarSlice = createSlice({
    name: 'snackBar',
    initialState: {
        open: false,
        message: "",
        severity: 'info'
    },
    reducers: {
        showSnackBar: (state, action) => {
            state.open = true;
            state.message = action?.payload?.message || ''
            state.severity = action?.payload?.severity || 'info'
        },
        hideSnackBar: (state) => {
            state.open = false;
            state.message = ''
        }
    }
})

export const {showSnackBar, hideSnackBar} = snackBarSlice.actions
export const snackBarReducer = snackBarSlice.reducer